<template>
  <BaseModal
  :is-visible="isVisible"
  :is-editable="false"
  :is-archivable="false"
  @hideModal="toggleModal()"
  size="xl"
  >
  <template #header></template>
  <template #body>
    <b-row>
      <b-col sm="12" md="3">
        <div class="form-group">
          <label class="form-control-label">{{$t('views.exsbsettlements.show.invoiceType')}}:</label>
          <fg-input>
            <el-select
              class="select-default"
              filterable
              remote
              reserve-keyword
              v-model="data.invoiceType">
              <el-option v-for="option in invoiceTypeOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
      <b-col sm="12" md="3">
        <div class="form-group">
          <label class="form-control-label">{{$t('views.exsbsettlements.show.batchNumber')}}:</label>
          <fg-input>
            <el-select
              class="select-default"
              filterable
              :disabled="data.invoiceType === null"
              remote
              reserve-keyword
              v-model="data.batchNumber">
              <el-option v-for="option in batchNumberOptions"
                         class="select-default"
                         :value="option.value"
                         :label="option.name"
                         :key="option.value">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
      <b-col sm="12" md="3">
        <div class="form-group">
          <label class="form-control-label">{{$t('views.exsbsettlements.show.paymentWay')}}:</label>
          <fg-input>
            <el-select
              class="select-default"
              filterable
              remote
              reserve-keyword
              v-model="data.paymentWay">
              <el-option v-for="option in paymentWayOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
      <b-col sm="12" md="3">
        <div class="form-group">
          <label class="form-control-label">{{$t('views.exsbsettlements.show.invoiceStatus')}}:</label>
          <fg-input>
            <el-select
              class="select-default"
              filterable
              remote
              reserve-keyword
              v-model="data.invoiceStatus">
              <el-option v-for="option in invoiceStatusOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
      <b-col sm="12" md="3">
        <div class="form-group">
          <label class="form-control-label">{{$t('views.exsbsettlements.show.paymentDeadline')}}:</label>
          <fg-input>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="data.paymentDeadline"
              type="date"
              :placeholder="$t('views.exsbsettlements.show.paymentDeadline')"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </fg-input>
        </div>
      </b-col>
      <b-col sm="12" md="3">
        <div class="form-group">
          <label class="form-control-label">{{$t('views.exsbinvoices.list.sellDate')}}:</label>
          <fg-input>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="data.sellDate"
              type="date"
              :placeholder="$t('views.exsbinvoices.list.sellDate')"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ positions.length }}</b></p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn variant="success" @click="generateInvoice()">{{ $t('buttons.generate') }}</b-btn>
        <b-btn @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </template>
  </BaseModal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseModal from '@/components/BaseComponents/BaseModal'

export default {
  name: 'GenerateInvoiceFromPositionsModal',
  components: {
    BaseModal
  },
  props: ['positions'],
  computed: {
    ...mapGetters({
      isVisible: 'exsbinvoice/generateFromPositionsModal/isVisible',
      created: 'exsbinvoice/generateFromPositionsModal/created',
      data: 'exsbinvoice/generateFromPositionsModal/data',
      documentTypeOptions: 'exsbinvoice/list/documentTypeOptions',
      invoiceTypeOptions: 'exsbinvoice/list/invoiceTypeOptions',
      invoiceStatusOptions: 'exsbinvoice/list/invoiceStatusOptions',
      paymentWayOptions: 'exsbinvoice/list/paymentWayOptions',
      batchNumberOptions: 'exsbinvoice/list/batchNumberOptions'
    })
  },
  created () {
    this.getInvoiceTypes()
    this.getBatchNumbers()
    this.getPaymentWays()
    this.getInvoiceStatuses()
    this.setPositions(this.positions)
  },
  watch: {
    created (val) {
      if (val) {
        this.$router.push({ name: 'EXSBInvoiceShow', params: { id: val['@id'] } })
      }
    }
  },
  methods: {
    setPositions (positions) {
      this.data.positions = positions
    },
    closeModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/generateFromPositionsModal/toggleModal'
    }),
    ...mapActions({
      getInvoiceStatuses: 'exsbinvoice/list/fetchInvoiceStatusOptions',
      getPaymentWays: 'exsbinvoice/list/fetchPaymentWayOptions',
      getInvoiceTypes: 'exsbinvoice/list/fetchInvoiceTypeOptions',
      getBatchNumbers: 'exsbinvoice/list/fetchBatchNumberOptions',
      generateInvoice: 'exsbinvoice/generateFromPositionsModal/generateInvoice'
    })
  }
}
</script>

<style scoped>

</style>
